import SeoHead from '../../components/feature/SeoHead';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Desguace en Martorell – Compra de Coches',
  description: 'Compramos coches en Martorell al mejor precio. Siniestrados, averiados, sin ITV. Recogida gratuita y pago inmediato.',
  provider: {
    '@type': 'AutoDealer',
    name: 'Desguace Barcelona',
    telephone: '+34932932913',
    address: { '@type': 'PostalAddress', addressLocality: 'Martorell', addressRegion: 'Cataluña', addressCountry: 'ES' },
  },
  areaServed: { '@type': 'City', name: 'Martorell' },
  url: `${siteUrl}/desguace-martorell`,
};

export default function DesguaceMartorellPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Desguace en Martorell | Vende tu Coche al Mejor Precio | Recogida Gratis"
        description="Desguace en Martorell. Compramos coches siniestrados, averiados o sin ITV al mejor precio. Recogida gratuita en Martorell y Baix Llobregat. Pago inmediato."
        keywords="desguace Martorell, vender coche Martorell, compra coches Martorell, desguace Baix Llobregat"
        canonical={`${siteUrl}/desguace-martorell`}
        jsonLd={jsonLd}
      />
      <Navbar />
      
      <div className="pt-32 pb-20 bg-gradient-to-br from-[#f8f9fa] to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-[#1a2332] mb-6 leading-tight">
              Desguace en Martorell
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Compramos tu coche en Martorell al mejor precio. Servicio rápido, profesional y con recogida gratuita en cualquier zona de la ciudad.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#ff6b35] rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-map-pin-line text-white text-2xl"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#1a2332]">Zonas de Martorell que Cubrimos</h2>
              </div>
              <ul className="space-y-3">
                <li className="flex items-center text-gray-700">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] mr-3"></i>
                  Martorell Centro
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] mr-3"></i>
                  El Pla
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] mr-3"></i>
                  Can Cases
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] mr-3"></i>
                  Torrent de Llops
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] mr-3"></i>
                  La Riera
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] mr-3"></i>
                  Polígono Industrial
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] mr-3"></i>
                  Rosanes
                </li>
                <li className="flex items-center text-gray-700">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] mr-3"></i>
                  El Pont del Diable
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#ff6b35] rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-star-line text-white text-2xl"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#1a2332]">Ventajas en Martorell</h2>
              </div>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <i className="ri-check-line text-[#ff6b35] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Recogida gratuita</strong> en todo Martorell y alrededores</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#ff6b35] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Tasación inmediata</strong> por WhatsApp o teléfono</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#ff6b35] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Pago al instante</strong> en efectivo o transferencia</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#ff6b35] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Gestión completa</strong> de toda la documentación</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#ff6b35] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Servicio en 24-48h</strong> desde tu llamada</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#ff6b35] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Sin compromiso</strong> - Tasación gratuita</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-r from-[#ff6b35] to-[#ff8c5a] rounded-2xl shadow-xl p-12 text-center mb-20">
            <h2 className="text-3xl font-bold text-white mb-4">
              ¿Tienes un coche en Martorell que quieres vender?
            </h2>
            <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
              Contacta ahora y recibe una tasación gratuita en minutos. Compramos todo tipo de vehículos en cualquier estado.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a 
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20vender%20mi%20coche%20en%20Martorell" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#25D366] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#1da851] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center"
              >
                <i className="ri-whatsapp-line mr-2 text-xl"></i>
                WhatsApp: 932 932 913
              </a>
              <a 
                href="tel:+34932932913" 
                className="bg-white text-[#ff6b35] px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center"
              >
                <i className="ri-phone-line mr-2 text-xl"></i>
                Llamar Ahora
              </a>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
            <h2 className="text-3xl font-bold text-[#1a2332] mb-8 text-center">
              Tipos de Coches que Compramos en Martorell
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="flex items-start p-4 bg-[#f8f9fa] rounded-lg">
                <i className="ri-car-line text-[#ff6b35] text-2xl mr-3 mt-1"></i>
                <div>
                  <h3 className="font-semibold text-[#1a2332] mb-1">Coches Siniestrados</h3>
                  <p className="text-sm text-gray-600">Accidentes, golpes, daños estructurales</p>
                </div>
              </div>
              <div className="flex items-start p-4 bg-[#f8f9fa] rounded-lg">
                <i className="ri-tools-line text-[#ff6b35] text-2xl mr-3 mt-1"></i>
                <div>
                  <h3 className="font-semibold text-[#1a2332] mb-1">Coches Averiados</h3>
                  <p className="text-sm text-gray-600">Problemas mecánicos, motor, transmisión</p>
                </div>
              </div>
              <div className="flex items-start p-4 bg-[#f8f9fa] rounded-lg">
                <i className="ri-file-warning-line text-[#ff6b35] text-2xl mr-3 mt-1"></i>
                <div>
                  <h3 className="font-semibold text-[#1a2332] mb-1">Coches Sin ITV</h3>
                  <p className="text-sm text-gray-600">ITV caducada, no pasa inspección</p>
                </div>
              </div>
              <div className="flex items-start p-4 bg-[#f8f9fa] rounded-lg">
                <i className="ri-time-line text-[#ff6b35] text-2xl mr-3 mt-1"></i>
                <div>
                  <h3 className="font-semibold text-[#1a2332] mb-1">Coches Antiguos</h3>
                  <p className="text-sm text-gray-600">Vehículos de más de 15 años</p>
                </div>
              </div>
              <div className="flex items-start p-4 bg-[#f8f9fa] rounded-lg">
                <i className="ri-fire-line text-[#ff6b35] text-2xl mr-3 mt-1"></i>
                <div>
                  <h3 className="font-semibold text-[#1a2332] mb-1">Coches Quemados</h3>
                  <p className="text-sm text-gray-600">Daños por fuego o incendio</p>
                </div>
              </div>
              <div className="flex items-start p-4 bg-[#f8f9fa] rounded-lg">
                <i className="ri-water-flash-line text-[#ff6b35] text-2xl mr-3 mt-1"></i>
                <div>
                  <h3 className="font-semibold text-[#1a2332] mb-1">Coches Inundados</h3>
                  <p className="text-sm text-gray-600">Daños por agua o inundación</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
